import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../shared/source/context/context';
import { jobArchitecturePermissionsSchema } from '../../../../shared/source/data-contract/job-architecture';

import type { JobArchitecturePermissions } from '../../../../shared/source/data-contract/job-architecture';
import type { Pathname } from '../../../../shared/source/http-fetcher/http-fetcher';
import type { UseQueryResult } from '@tanstack/react-query';
import type Result from 'true-myth/result';

const pathname: Pathname = '/job-architectures/options';

export const useJobArchitectureOptionsQuery = (): UseQueryResult<Result<JobArchitecturePermissions, Error>> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    return useQuery({
        queryFn: () =>
            validatingCobrainerApiFetcher.get(jobArchitecturePermissionsSchema, {
                pathname,
            }),
        queryKey: [pathname, 'get', jobArchitecturePermissionsSchema],
    });
};
